export default [
    {
        name: 'form_appraisal_enrich',
        path: '/form/appraisal-enrich/:referralId',
        meta: { anonymous: true, showSidebar: false },
        props: true,
        component: () => import(/* webpackChunkName: "form_appraisal_enrich" */ '../../views/Form/AppraisalEnrich.vue'),
        children: [
            {
                name: 'form_appraisal_enrich_intro',
                path: '',
                meta: { anonymous: true, showSidebar: false },
                props: true,
                component: () => import(/* webpackChunkName: "form_appraisal_enrich_intro" */ '../../views/Form/AppraisalEnrich/Intro.vue'),
            },
            {
                name: 'form_appraisal_enrich_edit',
                path: 'edit',
                meta: { anonymous: true, showSidebar: false },
                props: true,
                component: () => import(/* webpackChunkName: "form_appraisal_enrich_edit" */ '../../views/Form/AppraisalEnrich/Edit.vue'),
            },
            {
                name: 'form_appraisal_enrich_completed',
                path: 'completed',
                meta: { anonymous: true, showSidebar: false },
                props: true,
                component: () => import(/* webpackChunkName: "form_appraisal_enrich_completed" */ '../../views/Form/AppraisalEnrich/Completed.vue'),
            },
        ],
    },
    {
        name: 'appraisal',
        path: '/appraisal',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false, noBackground: true },
        component: () => import(/* webpackChunkName: "appraisal" */ '../../views/Form/Appraisal.vue'),
    },
    {
        name: 'appraisal_form',
        path: '/appraisal_form',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false, noBackground: true },
        component: () => import(/* webpackChunkName: "appraisal_form" */ '../../views/Form/AppraisalForm.vue'),
    },
    {
        name: 'agent_costs',
        path: '/agent_costs',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false },
        component: () => import(/* webpackChunkName: "appraisal" */ '../../views/Form/AgentCosts.vue'),
    },
    {
        name: 'information',
        path: '/information',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false },
        component: () => import(/* webpackChunkName: "information" */ '../../views/Form/Information.vue'),
    },
    {
        name: 'checklist',
        path: '/checklist',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false },
        component: () => import(/* webpackChunkName: "appraisal" */ '../../views/Form/Checklist.vue'),
    },
]
